import Vue from 'vue';
import Notifications from 'vue-notification'
import App from './App.vue';
import http from './http'
import router from './router';
import store from "./store";
import plugins from "./plugins";

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import { Vue as VueIntegration } from '@sentry/integrations'

import Clipboard from "v-clipboard";
import Vue2Filters from 'vue2-filters'
import VueGtag from 'vue-gtag'
import "./assets/scss/main.scss";
import constants from "@/config/constants";
import vuetify from './plugins/vuetify'


Vue.use(Notifications)
Vue.use(Clipboard)
Vue.use(Vue2Filters)

Sentry.init({
    Vue,
    dsn: constants.SENTRY_DSN,
    autoSessionTracking: true,
    integrations: [
        new VueIntegration({
            Vue,
            tracing: true
        }),
        new Integrations.BrowserTracing()
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});

Vue.use(VueGtag, {
    config: {id: constants.GOOGLE_ANALYTICS_ID},
    includes: [
        {id: constants.GOOGLE_GLOBAL_TAG_ID},
        {id: constants.GOOGLE_ADWORDS_TAG_ID}
    ],
    enabled: process.env.NODE_ENV === 'production'
}, router);

Vue.config.productionTip = false

new Vue({
    router,
    http,
    store,
    plugins,
    vuetify,
    render: h => h(App)
}).$mount('#app')
